// @ts-check
import { Flex, Separator } from 'components/base/layout-components';
import { SPACES } from 'common/constants/sizes';
import Text, { Inline } from 'components/base/Text';
import * as LighthouseService from 'common/services/lighthouse.service';
import { ARTICLE_IDS } from 'common/constants/constants';
import { LBButton } from '@linearb/buzz';
import Icon from 'components/base/Icon';

const GeneralTopHeaders = ({ settings = [] }) => {
  const numOfConnectedTeams = settings
    ? Object.entries(settings).filter(([_key, value]) => value.slackChannel)
        .length
    : 0;

  const numOfNotifiedTeams = settings
    ? Object.entries(settings).filter(
        ([_key, value]) => value.slackChannel && value.isNotificationEnabled
      ).length
    : 0;

  return (
    <Flex direction='row' items='center' width='100%' pb='x-medium'>
      <Flex direction='column' grow='1'>
        <Flex pb='small' items='center'>
          <Inline
            size='large'
            transform='uppercase'
            letterSpacing='0.6px'
            pr={SPACES.small}
          >
            slack notifications
          </Inline>
          <Flex items='center'>
            <Text color='osloGray' size='medium'>
              {numOfConnectedTeams} Teams connected
            </Text>
            <Separator margin='0 1rem' />
            <Text color='osloGray' size='medium'>
              {numOfNotifiedTeams} receiving notifications
            </Text>
          </Flex>
        </Flex>
        <Text size='large' color='shuttleGray'>
          Connect your team Slack channel to receive LinearB real time
          notifications
          <span className='ml-2'>
            <LBButton
              variant='outline'
              onClick={() =>
                LighthouseService.navigateArticle(ARTICLE_IDS.CONNECT_SLACK)
              }
            >
              what are notifications?
              <Icon name='helpicon' size='smaller' />
            </LBButton>
          </span>
        </Text>
      </Flex>
    </Flex>
  );
};

export default GeneralTopHeaders;
